/* unplugin-vue-components disabled */import { render } from "./SVideo.vue?vue&type=template&id=9bcfa3c6&scoped=true&ts=true"
import script from "./SVideo.vue?vue&type=script&lang=ts"
export * from "./SVideo.vue?vue&type=script&lang=ts"

import "./SVideo.vue?vue&type=style&index=0&id=9bcfa3c6&scoped=true&lang=css"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bcfa3c6"],['__file',"src/views/searchContent/cpns/SVideo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9bcfa3c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9bcfa3c6', __exports__)) {
    console.log('reload')
    api.reload('9bcfa3c6', __exports__)
  }
  
  module.hot.accept("./SVideo.vue?vue&type=template&id=9bcfa3c6&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('9bcfa3c6', render)
  })

}


export default __exports__